export const programmingLanguages = [
  {
    label: '@Formula',
    value: '@Formula',
  },
  {
    label: 'A-0 System',
    value: 'A-0 System',
  },
  {
    label: 'A# .NET',
    value: 'A# .NET',
  },
  {
    label: 'A# (Axiom)',
    value: 'A# (Axiom)',
  },
  {
    label: 'A+',
    value: 'A+',
  },
  {
    label: 'A++',
    value: 'A++',
  },
  {
    label: 'ABAP',
    value: 'ABAP',
  },
  {
    label: 'ABC',
    value: 'ABC',
  },
  {
    label: 'ABC ALGOL',
    value: 'ABC ALGOL',
  },
  {
    label: 'ABSET',
    value: 'ABSET',
  },
  {
    label: 'ABSYS',
    value: 'ABSYS',
  },
  {
    label: 'ACC',
    value: 'ACC',
  },
  {
    label: 'Accent',
    value: 'Accent',
  },
  {
    label: 'Ace DASL',
    value: 'Ace DASL',
  },
  {
    label: 'ACL2',
    value: 'ACL2',
  },
  {
    label: 'ACT-III',
    value: 'ACT-III',
  },
  {
    label: 'Action!',
    value: 'Action!',
  },
  {
    label: 'ActionScript',
    value: 'ActionScript',
  },
  {
    label: 'Active Server Pages',
    value: 'Active Server Pages',
  },
  {
    label: 'Ada',
    value: 'Ada',
  },
  {
    label: 'Adenine',
    value: 'Adenine',
  },
  {
    label: 'Agda',
    value: 'Agda',
  },
  {
    label: 'Agilent VEE',
    value: 'Agilent VEE',
  },
  {
    label: 'Agora',
    value: 'Agora',
  },
  {
    label: 'AIMMS',
    value: 'AIMMS',
  },
  {
    label: 'Alef',
    value: 'Alef',
  },
  {
    label: 'ALF',
    value: 'ALF',
  },
  {
    label: 'ALGOL 58',
    value: 'ALGOL 58',
  },
  {
    label: 'ALGOL 60',
    value: 'ALGOL 60',
  },
  {
    label: 'ALGOL 68',
    value: 'ALGOL 68',
  },
  {
    label: 'ALGOL W',
    value: 'ALGOL W',
  },
  {
    label: 'Alice',
    value: 'Alice',
  },
  {
    label: 'Alma-0',
    value: 'Alma-0',
  },
  {
    label: 'AmbientTalk',
    value: 'AmbientTalk',
  },
  {
    label: 'Amiga E',
    value: 'Amiga E',
  },
  {
    label: 'AMOS',
    value: 'AMOS',
  },
  {
    label: 'AMPL',
    value: 'AMPL',
  },
  {
    label: 'Apex',
    value: 'Apex',
  },
  {
    label: 'APL',
    value: 'APL',
  },
  {
    label: "App Inventor for Android's visual block language",
    value: "App Inventor for Android's visual block language",
  },
  {
    label: 'AppleScript',
    value: 'AppleScript',
  },
  {
    label: 'Arc',
    value: 'Arc',
  },
  {
    label: 'ARexx',
    value: 'ARexx',
  },
  {
    label: 'Argus',
    value: 'Argus',
  },
  {
    label: 'ASP.NET',
    value: 'ASP.NET',
  },
  {
    label: 'AspectJ',
    value: 'AspectJ',
  },
  {
    label: 'Assembly language',
    value: 'Assembly language',
  },
  {
    label: 'Ateji PX',
    value: 'Ateji PX',
  },
  {
    label: 'ATS',
    value: 'ATS',
  },
  {
    label: 'Autocoder',
    value: 'Autocoder',
  },
  {
    label: 'AutoHotkey',
    value: 'AutoHotkey',
  },
  {
    label: 'AutoIt',
    value: 'AutoIt',
  },
  {
    label: 'AutoLISP / Visual LISP',
    value: 'AutoLISP / Visual LISP',
  },
  {
    label: 'Averest',
    value: 'Averest',
  },
  {
    label: 'Avicsoft',
    value: 'Avicsoft',
  },
  {
    label: 'AWK',
    value: 'AWK',
  },
  {
    label: 'Axum',
    value: 'Axum',
  },
  {
    label: 'B',
    value: 'B',
  },
  {
    label: 'Babbage',
    value: 'Babbage',
  },
  {
    label: 'bash',
    value: 'bash',
  },
  {
    label: 'BASIC',
    value: 'BASIC',
  },
  {
    label: 'Batch (Windows/Dos)',
    value: 'Batch (Windows/Dos)',
  },
  {
    label: 'bc',
    value: 'bc',
  },
  {
    label: 'BCPL',
    value: 'BCPL',
  },
  {
    label: 'BeanShell',
    value: 'BeanShell',
  },
  {
    label: 'Bertrand',
    value: 'Bertrand',
  },
  {
    label: 'BETA',
    value: 'BETA',
  },
  {
    label: 'Bigwig',
    value: 'Bigwig',
  },
  {
    label: 'Bistro',
    value: 'Bistro',
  },
  {
    label: 'BitC',
    value: 'BitC',
  },
  {
    label: 'BLISS',
    value: 'BLISS',
  },
  {
    label: 'Blockly',
    value: 'Blockly',
  },
  {
    label: 'BlooP',
    value: 'BlooP',
  },
  {
    label: 'Blue',
    value: 'Blue',
  },
  {
    label: 'Boo',
    value: 'Boo',
  },
  {
    label: 'Boomerang',
    value: 'Boomerang',
  },
  {
    label: 'Bourne shell',
    value: 'Bourne shell',
  },
  {
    label: 'BPEL',
    value: 'BPEL',
  },
  {
    label: 'BREW',
    value: 'BREW',
  },
  {
    label: 'Business Basic',
    value: 'Business Basic',
  },
  {
    label: 'C',
    value: 'C',
  },
  {
    label: 'C Shell',
    value: 'C Shell',
  },
  {
    label: 'C--',
    value: 'C--',
  },
  {
    label: 'C/AL',
    value: 'C/AL',
  },
  {
    label: 'C#',
    value: 'C#',
  },
  {
    label: 'C++',
    value: 'C++',
  },
  {
    label: 'Caché ObjectScript',
    value: 'Caché ObjectScript',
  },
  {
    label: 'Caml',
    value: 'Caml',
  },
  {
    label: 'Cayenne',
    value: 'Cayenne',
  },
  {
    label: 'CDuce',
    value: 'CDuce',
  },
  {
    label: 'Cecil',
    value: 'Cecil',
  },
  {
    label: 'Cesil',
    value: 'Cesil',
  },
  {
    label: 'Céu',
    value: 'Céu',
  },
  {
    label: 'Ceylon',
    value: 'Ceylon',
  },
  {
    label: 'CFEngine',
    value: 'CFEngine',
  },
  {
    label: 'CFML',
    value: 'CFML',
  },
  {
    label: 'Cg',
    value: 'Cg',
  },
  {
    label: 'Ch',
    value: 'Ch',
  },
  {
    label: 'Chapel',
    value: 'Chapel',
  },
  {
    label: 'Charity',
    value: 'Charity',
  },
  {
    label: 'Charm',
    value: 'Charm',
  },
  {
    label: 'Chef',
    value: 'Chef',
  },
  {
    label: 'CHILL',
    value: 'CHILL',
  },
  {
    label: 'CHIP-8',
    value: 'CHIP-8',
  },
  {
    label: 'chomski',
    value: 'chomski',
  },
  {
    label: 'ChucK',
    value: 'ChucK',
  },
  {
    label: 'CICS',
    value: 'CICS',
  },
  {
    label: 'CIL',
    value: 'CIL',
  },
  {
    label: 'Cilk',
    value: 'Cilk',
  },
  {
    label: 'Citrine (programming language)',
    value: 'Citrine (programming language)',
  },
  {
    label: 'CL',
    value: 'CL',
  },
  {
    label: 'Claire',
    value: 'Claire',
  },
  {
    label: 'Clarion',
    value: 'Clarion',
  },
  {
    label: 'Clean',
    value: 'Clean',
  },
  {
    label: 'Clipper',
    value: 'Clipper',
  },
  {
    label: 'CLIPS',
    value: 'CLIPS',
  },
  {
    label: 'CLIST',
    value: 'CLIST',
  },
  {
    label: 'Clojure',
    value: 'Clojure',
  },
  {
    label: 'CLU',
    value: 'CLU',
  },
  {
    label: 'CMS EXEC',
    value: 'CMS EXEC',
  },
  {
    label: 'CMS-2',
    value: 'CMS-2',
  },
  {
    label: 'COBOL',
    value: 'COBOL',
  },
  {
    label: 'CobolScript',
    value: 'CobolScript',
  },
  {
    label: 'Cobra',
    value: 'Cobra',
  },
  {
    label: 'CODE',
    value: 'CODE',
  },
  {
    label: 'CoffeeScript',
    value: 'CoffeeScript',
  },
  {
    label: 'ColdFusion',
    value: 'ColdFusion',
  },
  {
    label: 'COMAL',
    value: 'COMAL',
  },
  {
    label: 'Combined Programming Language',
    value: 'Combined Programming Language',
  },
  {
    label: 'COMIT',
    value: 'COMIT',
  },
  {
    label: 'Common Lisp',
    value: 'Common Lisp',
  },
  {
    label: 'COMPASS',
    value: 'COMPASS',
  },
  {
    label: 'Component Pascal',
    value: 'Component Pascal',
  },
  {
    label: 'COMTRAN',
    value: 'COMTRAN',
  },
  {
    label: 'Constraint Handling Rules',
    value: 'Constraint Handling Rules',
  },
  {
    label: 'Converge',
    value: 'Converge',
  },
  {
    label: 'Cool',
    value: 'Cool',
  },
  {
    label: 'Coq',
    value: 'Coq',
  },
  {
    label: 'Coral 66',
    value: 'Coral 66',
  },
  {
    label: 'Corn',
    value: 'Corn',
  },
  {
    label: 'CorVision',
    value: 'CorVision',
  },
  {
    label: 'COWSEL',
    value: 'COWSEL',
  },
  {
    label: 'CPL',
    value: 'CPL',
  },
  {
    label: 'Cryptol',
    value: 'Cryptol',
  },
  {
    label: 'csh',
    value: 'csh',
  },
  {
    label: 'Csound',
    value: 'Csound',
  },
  {
    label: 'CSP',
    value: 'CSP',
  },
  {
    label: 'CUDA',
    value: 'CUDA',
  },
  {
    label: 'Curl',
    value: 'Curl',
  },
  {
    label: 'Curry',
    value: 'Curry',
  },
  {
    label: 'Cybil',
    value: 'Cybil',
  },
  {
    label: 'Cyclone',
    value: 'Cyclone',
  },
  {
    label: 'Cython',
    value: 'Cython',
  },
  {
    label: 'D',
    value: 'D',
  },
  {
    label: 'Dart',
    value: 'Dart',
  },
  {
    label: 'DASL',
    value: 'DASL',
  },
  {
    label: 'DataFlex',
    value: 'DataFlex',
  },
  {
    label: 'Datalog',
    value: 'Datalog',
  },
  {
    label: 'DATATRIEVE',
    value: 'DATATRIEVE',
  },
  {
    label: 'dBase',
    value: 'dBase',
  },
  {
    label: 'dc',
    value: 'dc',
  },
  {
    label: 'DCL',
    value: 'DCL',
  },
  {
    label: 'Deesel',
    value: 'Deesel',
  },
  {
    label: 'Delphi',
    value: 'Delphi',
  },
  {
    label: 'DIBOL',
    value: 'DIBOL',
  },
  {
    label: 'DinkC',
    value: 'DinkC',
  },
  {
    label: 'Dog',
    value: 'Dog',
  },
  {
    label: 'Draco',
    value: 'Draco',
  },
  {
    label: 'DRAKON',
    value: 'DRAKON',
  },
  {
    label: 'Dylan',
    value: 'Dylan',
  },
  {
    label: 'DYNAMO',
    value: 'DYNAMO',
  },
  {
    label: 'E',
    value: 'E',
  },
  {
    label: 'EarSketch',
    value: 'EarSketch',
  },
  {
    label: 'Ease',
    value: 'Ease',
  },
  {
    label: 'Easy PL/I',
    value: 'Easy PL/I',
  },
  {
    label: 'Easy Programming Language',
    value: 'Easy Programming Language',
  },
  {
    label: 'EASYTRIEVE PLUS',
    value: 'EASYTRIEVE PLUS',
  },
  {
    label: 'ECMAScript',
    value: 'ECMAScript',
  },
  {
    label: 'Edinburgh IMP',
    value: 'Edinburgh IMP',
  },
  {
    label: 'EGL',
    value: 'EGL',
  },
  {
    label: 'Eiffel',
    value: 'Eiffel',
  },
  {
    label: 'ELAN',
    value: 'ELAN',
  },
  {
    label: 'Elixir',
    value: 'Elixir',
  },
  {
    label: 'Elm',
    value: 'Elm',
  },
  {
    label: 'Emacs Lisp',
    value: 'Emacs Lisp',
  },
  {
    label: 'Emerald',
    value: 'Emerald',
  },
  {
    label: 'Epigram',
    value: 'Epigram',
  },
  {
    label: 'Erlang',
    value: 'Erlang',
  },
  {
    label: 'es',
    value: 'es',
  },
  {
    label: 'Escher',
    value: 'Escher',
  },
  {
    label: 'ESPOL',
    value: 'ESPOL',
  },
  {
    label: 'Esterel',
    value: 'Esterel',
  },
  {
    label: 'Etoys',
    value: 'Etoys',
  },
  {
    label: 'Euclid',
    value: 'Euclid',
  },
  {
    label: 'Euler',
    value: 'Euler',
  },
  {
    label: 'Euphoria',
    value: 'Euphoria',
  },
  {
    label: 'EusLisp Robot Programming Language',
    value: 'EusLisp Robot Programming Language',
  },
  {
    label: 'EXEC 2',
    value: 'EXEC 2',
  },
  {
    label: 'Executable UML',
    value: 'Executable UML',
  },
  {
    label: 'F',
    value: 'F',
  },
  {
    label: 'F-Script',
    value: 'F-Script',
  },
  {
    label: 'F#',
    value: 'F#',
  },
  {
    label: 'Factor',
    value: 'Factor',
  },
  {
    label: 'Falcon',
    value: 'Falcon',
  },
  {
    label: 'Fantom',
    value: 'Fantom',
  },
  {
    label: 'FAUST',
    value: 'FAUST',
  },
  {
    label: 'FFP',
    value: 'FFP',
  },
  {
    label: 'Fjölnir',
    value: 'Fjölnir',
  },
  {
    label: 'FL',
    value: 'FL',
  },
  {
    label: 'Flavors',
    value: 'Flavors',
  },
  {
    label: 'Flex',
    value: 'Flex',
  },
  {
    label: 'FLOW-MATIC',
    value: 'FLOW-MATIC',
  },
  {
    label: 'FOCAL',
    value: 'FOCAL',
  },
  {
    label: 'FOCUS',
    value: 'FOCUS',
  },
  {
    label: 'FOIL',
    value: 'FOIL',
  },
  {
    label: 'FORMAC',
    value: 'FORMAC',
  },
  {
    label: 'Forth',
    value: 'Forth',
  },
  {
    label: 'Fortran',
    value: 'Fortran',
  },
  {
    label: 'Fortress',
    value: 'Fortress',
  },
  {
    label: 'FoxBase',
    value: 'FoxBase',
  },
  {
    label: 'FoxPro',
    value: 'FoxPro',
  },
  {
    label: 'FP',
    value: 'FP',
  },
  {
    label: 'FPr',
    value: 'FPr',
  },
  {
    label: 'Franz Lisp',
    value: 'Franz Lisp',
  },
  {
    label: 'Frege',
    value: 'Frege',
  },
  {
    label: 'G',
    value: 'G',
  },
  {
    label: 'G-code',
    value: 'G-code',
  },
  {
    label: 'Game Maker Language',
    value: 'Game Maker Language',
  },
  {
    label: 'GameMonkey Script',
    value: 'GameMonkey Script',
  },
  {
    label: 'GAMS',
    value: 'GAMS',
  },
  {
    label: 'GAP',
    value: 'GAP',
  },
  {
    label: 'GDL',
    value: 'GDL',
  },
  {
    label: 'Genie',
    value: 'Genie',
  },
  {
    label: 'GEORGE',
    value: 'GEORGE',
  },
  {
    label: 'GJ',
    value: 'GJ',
  },
  {
    label: 'GLSL',
    value: 'GLSL',
  },
  {
    label: 'GM',
    value: 'GM',
  },
  {
    label: 'GNU E',
    value: 'GNU E',
  },
  {
    label: 'Go',
    value: 'Go',
  },
  {
    label: 'Go!',
    value: 'Go!',
  },
  {
    label: 'GOAL',
    value: 'GOAL',
  },
  {
    label: 'Gödel',
    value: 'Gödel',
  },
  {
    label: 'Golo',
    value: 'Golo',
  },
  {
    label: 'GOM (Good Old Mad)',
    value: 'GOM (Good Old Mad)',
  },
  {
    label: 'Google Apps Script',
    value: 'Google Apps Script',
  },
  {
    label: 'Gosu',
    value: 'Gosu',
  },
  {
    label: 'GOTRAN',
    value: 'GOTRAN',
  },
  {
    label: 'GPSS',
    value: 'GPSS',
  },
  {
    label: 'GraphTalk',
    value: 'GraphTalk',
  },
  {
    label: 'GRASS',
    value: 'GRASS',
  },
  {
    label: 'Groovy',
    value: 'Groovy',
  },
  {
    label: 'Hack',
    value: 'Hack',
  },
  {
    label: 'HAGGIS',
    value: 'HAGGIS',
  },
  {
    label: 'HAL/S',
    value: 'HAL/S',
  },
  {
    label: 'Hamilton C shell',
    value: 'Hamilton C shell',
  },
  {
    label: 'Harbour',
    value: 'Harbour',
  },
  {
    label: 'Hartmann pipelines',
    value: 'Hartmann pipelines',
  },
  {
    label: 'Haskell',
    value: 'Haskell',
  },
  {
    label: 'Haxe',
    value: 'Haxe',
  },
  {
    label: 'Hermes',
    value: 'Hermes',
  },
  {
    label: 'High Level Assembly',
    value: 'High Level Assembly',
  },
  {
    label: 'HLSL',
    value: 'HLSL',
  },
  {
    label: 'Hop',
    value: 'Hop',
  },
  {
    label: 'Hope',
    value: 'Hope',
  },
  {
    label: 'Hopscotch',
    value: 'Hopscotch',
  },
  {
    label: 'HTML',
    value: 'HTML',
  },
  {
    label: 'Hugo',
    value: 'Hugo',
  },
  {
    label: 'Hume',
    value: 'Hume',
  },
  {
    label: 'HyperTalk',
    value: 'HyperTalk',
  },
  {
    label: 'IBM Basic assembly language',
    value: 'IBM Basic assembly language',
  },
  {
    label: 'IBM HAScript',
    value: 'IBM HAScript',
  },
  {
    label: 'IBM Informix-4GL',
    value: 'IBM Informix-4GL',
  },
  {
    label: 'IBM RPG',
    value: 'IBM RPG',
  },
  {
    label: 'ICI',
    value: 'ICI',
  },
  {
    label: 'Icon',
    value: 'Icon',
  },
  {
    label: 'Id',
    value: 'Id',
  },
  {
    label: 'IDL',
    value: 'IDL',
  },
  {
    label: 'Idris',
    value: 'Idris',
  },
  {
    label: 'IMP',
    value: 'IMP',
  },
  {
    label: 'Inform',
    value: 'Inform',
  },
  {
    label: 'INTERLISP',
    value: 'INTERLISP',
  },
  {
    label: 'Io',
    value: 'Io',
  },
  {
    label: 'Ioke',
    value: 'Ioke',
  },
  {
    label: 'IPL',
    value: 'IPL',
  },
  {
    label: 'IPTSCRAE',
    value: 'IPTSCRAE',
  },
  {
    label: 'ISLISP',
    value: 'ISLISP',
  },
  {
    label: 'ISPF',
    value: 'ISPF',
  },
  {
    label: 'ISWIM',
    value: 'ISWIM',
  },
  {
    label: 'J',
    value: 'J',
  },
  {
    label: 'J#',
    value: 'J#',
  },
  {
    label: 'J++',
    value: 'J++',
  },
  {
    label: 'JADE',
    value: 'JADE',
  },
  {
    label: 'Jako',
    value: 'Jako',
  },
  {
    label: 'JAL',
    value: 'JAL',
  },
  {
    label: 'Janus (concurrent constraint programming language)',
    value: 'Janus (concurrent constraint programming language)',
  },
  {
    label: 'Janus (time-reversible computing programming language)',
    value: 'Janus (time-reversible computing programming language)',
  },
  {
    label: 'JASS',
    value: 'JASS',
  },
  {
    label: 'Java',
    value: 'Java',
  },
  {
    label: 'JavaFX Script',
    value: 'JavaFX Script',
  },
  {
    label: 'JavaScript',
    value: 'JavaScript',
  },
  {
    label: 'JCL',
    value: 'JCL',
  },
  {
    label: 'JEAN',
    value: 'JEAN',
  },
  {
    label: 'Join Java',
    value: 'Join Java',
  },
  {
    label: 'JOSS',
    value: 'JOSS',
  },
  {
    label: 'Joule',
    value: 'Joule',
  },
  {
    label: 'JOVIAL',
    value: 'JOVIAL',
  },
  {
    label: 'Joy',
    value: 'Joy',
  },
  {
    label: 'JScript',
    value: 'JScript',
  },
  {
    label: 'JScript .NET',
    value: 'JScript .NET',
  },
  {
    label: 'JSON',
    value: 'JSON',
  },
  {
    label: 'JSON-LD',
    value: 'JSON-LD',
  },
  {
    label: 'Julia',
    value: 'Julia',
  },
  {
    label: 'Jython',
    value: 'Jython',
  },
  {
    label: 'K',
    value: 'K',
  },
  {
    label: 'Kaleidoscope',
    value: 'Kaleidoscope',
  },
  {
    label: 'Karel',
    value: 'Karel',
  },
  {
    label: 'Karel++',
    value: 'Karel++',
  },
  {
    label: 'KEE',
    value: 'KEE',
  },
  {
    label: 'KIF',
    value: 'KIF',
  },
  {
    label: 'Kixtart',
    value: 'Kixtart',
  },
  {
    label: 'Klerer-May System',
    value: 'Klerer-May System',
  },
  {
    label: 'Kojo',
    value: 'Kojo',
  },
  {
    label: 'Kotlin',
    value: 'Kotlin',
  },
  {
    label: 'KRC',
    value: 'KRC',
  },
  {
    label: 'KRL',
    value: 'KRL',
  },
  {
    label: 'KRYPTON',
    value: 'KRYPTON',
  },
  {
    label: 'ksh',
    value: 'ksh',
  },
  {
    label: 'KUKA',
    value: 'KUKA',
  },
  {
    label: 'L',
    value: 'L',
  },
  {
    label: 'L# .NET',
    value: 'L# .NET',
  },
  {
    label: 'LabVIEW',
    value: 'LabVIEW',
  },
  {
    label: 'Ladder',
    value: 'Ladder',
  },
  {
    label: 'Lagoona',
    value: 'Lagoona',
  },
  {
    label: 'LANSA',
    value: 'LANSA',
  },
  {
    label: 'Lasso',
    value: 'Lasso',
  },
  {
    label: 'Lava',
    value: 'Lava',
  },
  {
    label: 'LC-3',
    value: 'LC-3',
  },
  {
    label: 'Leda',
    value: 'Leda',
  },
  {
    label: 'Legoscript',
    value: 'Legoscript',
  },
  {
    label: 'LIL',
    value: 'LIL',
  },
  {
    label: 'LilyPond',
    value: 'LilyPond',
  },
  {
    label: 'Limbo',
    value: 'Limbo',
  },
  {
    label: 'Limnor',
    value: 'Limnor',
  },
  {
    label: 'LINC',
    value: 'LINC',
  },
  {
    label: 'Lingo',
    value: 'Lingo',
  },
  {
    label: 'LIS',
    value: 'LIS',
  },
  {
    label: 'LISA',
    value: 'LISA',
  },
  {
    label: 'Lisaac',
    value: 'Lisaac',
  },
  {
    label: 'Lisp',
    value: 'Lisp',
  },
  {
    label: 'Lite-C',
    value: 'Lite-C',
  },
  {
    label: 'Lithe',
    value: 'Lithe',
  },
  {
    label: 'Little b',
    value: 'Little b',
  },
  {
    label: 'LiveScript',
    value: 'LiveScript',
  },
  {
    label: 'Logo',
    value: 'Logo',
  },
  {
    label: 'Logtalk',
    value: 'Logtalk',
  },
  {
    label: 'LotusScript',
    value: 'LotusScript',
  },
  {
    label: 'LPC',
    value: 'LPC',
  },
  {
    label: 'LSE',
    value: 'LSE',
  },
  {
    label: 'LSL',
    value: 'LSL',
  },
  {
    label: 'Lua',
    value: 'Lua',
  },
  {
    label: 'Lucid',
    value: 'Lucid',
  },
  {
    label: 'Lustre',
    value: 'Lustre',
  },
  {
    label: 'LYaPAS',
    value: 'LYaPAS',
  },
  {
    label: 'Lynx',
    value: 'Lynx',
  },
  {
    label: 'M#',
    value: 'M#',
  },
  {
    label: 'M2001',
    value: 'M2001',
  },
  {
    label: 'M4',
    value: 'M4',
  },
  {
    label: 'Machine code',
    value: 'Machine code',
  },
  {
    label: 'Macsyma',
    value: 'Macsyma',
  },
  {
    label: 'Magik',
    value: 'Magik',
  },
  {
    label: 'Magma',
    value: 'Magma',
  },
  {
    label: 'make',
    value: 'make',
  },
  {
    label: 'Maple',
    value: 'Maple',
  },
  {
    label: 'MAPPER',
    value: 'MAPPER',
  },
  {
    label: 'MARK-IV',
    value: 'MARK-IV',
  },
  {
    label: 'Markdown',
    value: 'Markdown',
  },
  {
    label: 'Mary',
    value: 'Mary',
  },
  {
    label: 'MASM Microsoft Assembly x86',
    value: 'MASM Microsoft Assembly x86',
  },
  {
    label: 'MATH-MATIC',
    value: 'MATH-MATIC',
  },
  {
    label: 'Mathcad',
    value: 'Mathcad',
  },
  {
    label: 'Mathematica',
    value: 'Mathematica',
  },
  {
    label: 'MathML',
    value: 'MathML',
  },
  {
    label: 'MATLAB',
    value: 'MATLAB',
  },
  {
    label: 'Max',
    value: 'Max',
  },
  {
    label: 'Maxima',
    value: 'Maxima',
  },
  {
    label: 'MaxScript',
    value: 'MaxScript',
  },
  {
    label: 'Maya (MEL)',
    value: 'Maya (MEL)',
  },
  {
    label: 'MDL',
    value: 'MDL',
  },
  {
    label: 'Mercury',
    value: 'Mercury',
  },
  {
    label: 'Mesa',
    value: 'Mesa',
  },
  {
    label: 'Metafont',
    value: 'Metafont',
  },
  {
    label: 'Microcode',
    value: 'Microcode',
  },
  {
    label: 'MicroScript',
    value: 'MicroScript',
  },
  {
    label: 'MIIS',
    value: 'MIIS',
  },
  {
    label: 'Milk (programming language)',
    value: 'Milk (programming language)',
  },
  {
    label: 'MIMIC',
    value: 'MIMIC',
  },
  {
    label: 'Mirah',
    value: 'Mirah',
  },
  {
    label: 'Miranda',
    value: 'Miranda',
  },
  {
    label: 'MIVA Script',
    value: 'MIVA Script',
  },
  {
    label: 'ML',
    value: 'ML',
  },
  {
    label: 'Model 204',
    value: 'Model 204',
  },
  {
    label: 'Modelica',
    value: 'Modelica',
  },
  {
    label: 'Modula',
    value: 'Modula',
  },
  {
    label: 'Modula-2',
    value: 'Modula-2',
  },
  {
    label: 'Modula-3',
    value: 'Modula-3',
  },
  {
    label: 'Mohol',
    value: 'Mohol',
  },
  {
    label: 'MOO',
    value: 'MOO',
  },
  {
    label: 'Mortran',
    value: 'Mortran',
  },
  {
    label: 'Mouse',
    value: 'Mouse',
  },
  {
    label: 'MPD',
    value: 'MPD',
  },
  {
    label: 'MSL',
    value: 'MSL',
  },
  {
    label: 'MUMPS',
    value: 'MUMPS',
  },
  {
    label: 'Mystic Programming Language',
    value: 'Mystic Programming Language',
  },
  {
    label: 'N-Quads',
    value: 'N-Quads',
  },
  {
    label: 'N-Triples',
    value: 'N-Triples',
  },
  {
    label: 'N3',
    value: 'N3',
  },
  {
    label: 'Napier88',
    value: 'Napier88',
  },
  {
    label: 'NASM',
    value: 'NASM',
  },
  {
    label: 'Neko',
    value: 'Neko',
  },
  {
    label: 'Nemerle',
    value: 'Nemerle',
  },
  {
    label: 'nesC',
    value: 'nesC',
  },
  {
    label: 'NESL',
    value: 'NESL',
  },
  {
    label: 'Net.Data',
    value: 'Net.Data',
  },
  {
    label: 'NetLogo',
    value: 'NetLogo',
  },
  {
    label: 'NetRexx',
    value: 'NetRexx',
  },
  {
    label: 'NewLISP',
    value: 'NewLISP',
  },
  {
    label: 'NEWP',
    value: 'NEWP',
  },
  {
    label: 'Newspeak',
    value: 'Newspeak',
  },
  {
    label: 'NewtonScript',
    value: 'NewtonScript',
  },
  {
    label: 'NGL',
    value: 'NGL',
  },
  {
    label: 'Nial',
    value: 'Nial',
  },
  {
    label: 'Nice',
    value: 'Nice',
  },
  {
    label: 'Nickle',
    value: 'Nickle',
  },
  {
    label: 'Nim',
    value: 'Nim',
  },
  {
    label: 'NO',
    value: 'NO',
  },
  {
    label: 'Not eXactly C',
    value: 'Not eXactly C',
  },
  {
    label: 'Not Quite C',
    value: 'Not Quite C',
  },
  {
    label: 'NPL',
    value: 'NPL',
  },
  {
    label: 'NSIS',
    value: 'NSIS',
  },
  {
    label: 'Nu',
    value: 'Nu',
  },
  {
    label: 'Numpy',
    value: 'Numpy',
  },
  {
    label: 'NWScript',
    value: 'NWScript',
  },
  {
    label: 'NXT-G',
    value: 'NXT-G',
  },
  {
    label: 'o:XML',
    value: 'o:XML',
  },
  {
    label: 'Oak',
    value: 'Oak',
  },
  {
    label: 'Oberon',
    value: 'Oberon',
  },
  {
    label: 'OBJ2',
    value: 'OBJ2',
  },
  {
    label: 'Object Lisp',
    value: 'Object Lisp',
  },
  {
    label: 'Object Pascal',
    value: 'Object Pascal',
  },
  {
    label: 'Object REXX',
    value: 'Object REXX',
  },
  {
    label: 'Objective-C',
    value: 'Objective-C',
  },
  {
    label: 'Objective-J',
    value: 'Objective-J',
  },
  {
    label: 'ObjectLOGO',
    value: 'ObjectLOGO',
  },
  {
    label: 'Obliq',
    value: 'Obliq',
  },
  {
    label: 'OCaml',
    value: 'OCaml',
  },
  {
    label: 'occam',
    value: 'occam',
  },
  {
    label: 'occam-π',
    value: 'occam-π',
  },
  {
    label: 'Octave',
    value: 'Octave',
  },
  {
    label: 'OmniMark',
    value: 'OmniMark',
  },
  {
    label: 'Onyx',
    value: 'Onyx',
  },
  {
    label: 'Opa',
    value: 'Opa',
  },
  {
    label: 'Opal',
    value: 'Opal',
  },
  {
    label: 'OpenCL',
    value: 'OpenCL',
  },
  {
    label: 'OpenEdge ABL',
    value: 'OpenEdge ABL',
  },
  {
    label: 'OpenVera',
    value: 'OpenVera',
  },
  {
    label: 'OPL',
    value: 'OPL',
  },
  {
    label: 'OPS5',
    value: 'OPS5',
  },
  {
    label: 'OptimJ',
    value: 'OptimJ',
  },
  {
    label: 'Orc',
    value: 'Orc',
  },
  {
    label: 'ORCA/Modula-2',
    value: 'ORCA/Modula-2',
  },
  {
    label: 'Oriel',
    value: 'Oriel',
  },
  {
    label: 'Orwell',
    value: 'Orwell',
  },
  {
    label: 'Oxygene',
    value: 'Oxygene',
  },
  {
    label: 'Oz',
    value: 'Oz',
  },
  {
    label: 'P#',
    value: 'P#',
  },
  {
    label: 'P′′',
    value: 'P′′',
  },
  {
    label: 'ParaSail (programming language)',
    value: 'ParaSail (programming language)',
  },
  {
    label: 'PARI/GP',
    value: 'PARI/GP',
  },
  {
    label: 'Pascal',
    value: 'Pascal',
  },
  {
    label: 'PCASTL',
    value: 'PCASTL',
  },
  {
    label: 'PCF',
    value: 'PCF',
  },
  {
    label: 'PDL',
    value: 'PDL',
  },
  {
    label: 'PEARL',
    value: 'PEARL',
  },
  {
    label: 'PeopleCode',
    value: 'PeopleCode',
  },
  {
    label: 'Perl',
    value: 'Perl',
  },
  {
    label: 'Perl6',
    value: 'Perl6',
  },
  {
    label: 'Pharo',
    value: 'Pharo',
  },
  {
    label: 'PHP',
    value: 'PHP',
  },
  {
    label: 'Phrogram',
    value: 'Phrogram',
  },
  {
    label: 'Pico',
    value: 'Pico',
  },
  {
    label: 'Picolisp',
    value: 'Picolisp',
  },
  {
    label: 'Pict',
    value: 'Pict',
  },
  {
    label: 'Pike',
    value: 'Pike',
  },
  {
    label: 'PIKT',
    value: 'PIKT',
  },
  {
    label: 'PILOT',
    value: 'PILOT',
  },
  {
    label: 'Pizza',
    value: 'Pizza',
  },
  {
    label: 'PL-11',
    value: 'PL-11',
  },
  {
    label: 'PL/0',
    value: 'PL/0',
  },
  {
    label: 'PL/B',
    value: 'PL/B',
  },
  {
    label: 'PL/C',
    value: 'PL/C',
  },
  {
    label: 'PL/M',
    value: 'PL/M',
  },
  {
    label: 'PL/P',
    value: 'PL/P',
  },
  {
    label: 'PL/SQL',
    value: 'PL/SQL',
  },
  {
    label: 'PL360',
    value: 'PL360',
  },
  {
    label: 'PLANC',
    value: 'PLANC',
  },
  {
    label: 'Plankalkül',
    value: 'Plankalkül',
  },
  {
    label: 'Planner',
    value: 'Planner',
  },
  {
    label: 'PLEX',
    value: 'PLEX',
  },
  {
    label: 'PLEXIL',
    value: 'PLEXIL',
  },
  {
    label: 'Plus',
    value: 'Plus',
  },
  {
    label: 'POP-11',
    value: 'POP-11',
  },
  {
    label: 'POP-2',
    value: 'POP-2',
  },
  {
    label: 'PortablE',
    value: 'PortablE',
  },
  {
    label: 'PostScript',
    value: 'PostScript',
  },
  {
    label: 'PowerBuilder',
    value: 'PowerBuilder',
  },
  {
    label: 'Powerhouse',
    value: 'Powerhouse',
  },
  {
    label: 'PowerShell',
    value: 'PowerShell',
  },
  {
    label: 'PPL',
    value: 'PPL',
  },
  {
    label: 'Pro*C',
    value: 'Pro*C',
  },
  {
    label: 'Processing',
    value: 'Processing',
  },
  {
    label: 'Processing.js',
    value: 'Processing.js',
  },
  {
    label: 'Prograph',
    value: 'Prograph',
  },
  {
    label: 'PROIV',
    value: 'PROIV',
  },
  {
    label: 'Prolog',
    value: 'Prolog',
  },
  {
    label: 'PROMAL',
    value: 'PROMAL',
  },
  {
    label: 'Promela',
    value: 'Promela',
  },
  {
    label: 'PROSE modeling language',
    value: 'PROSE modeling language',
  },
  {
    label: 'PROTEL',
    value: 'PROTEL',
  },
  {
    label: 'ProvideX',
    value: 'ProvideX',
  },
  {
    label: 'Pure',
    value: 'Pure',
  },
  {
    label: 'Pure Data',
    value: 'Pure Data',
  },
  {
    label: 'Python',
    value: 'Python',
  },
  {
    label: 'Q (equational programming language)',
    value: 'Q (equational programming language)',
  },
  {
    label: 'Q (programming language from Kx Systems)',
    value: 'Q (programming language from Kx Systems)',
  },
  {
    label: 'Qalb',
    value: 'Qalb',
  },
  {
    label: 'QPL',
    value: 'QPL',
  },
  {
    label: 'QtScript',
    value: 'QtScript',
  },
  {
    label: 'QuakeC',
    value: 'QuakeC',
  },
  {
    label: 'R',
    value: 'R',
  },
  {
    label: 'R++',
    value: 'R++',
  },
  {
    label: 'Racket',
    value: 'Racket',
  },
  {
    label: 'RAPID',
    value: 'RAPID',
  },
  {
    label: 'Rapira',
    value: 'Rapira',
  },
  {
    label: 'Ratfiv',
    value: 'Ratfiv',
  },
  {
    label: 'Ratfor',
    value: 'Ratfor',
  },
  {
    label: 'rc',
    value: 'rc',
  },
  {
    label: 'REBOL',
    value: 'REBOL',
  },
  {
    label: 'Red',
    value: 'Red',
  },
  {
    label: 'Redcode',
    value: 'Redcode',
  },
  {
    label: 'REFAL',
    value: 'REFAL',
  },
  {
    label: 'Reia',
    value: 'Reia',
  },
  {
    label: 'REXX',
    value: 'REXX',
  },
  {
    label: 'Rlab',
    value: 'Rlab',
  },
  {
    label: 'ROOP',
    value: 'ROOP',
  },
  {
    label: 'RPL',
    value: 'RPL',
  },
  {
    label: 'RSL',
    value: 'RSL',
  },
  {
    label: 'RTL/2',
    value: 'RTL/2',
  },
  {
    label: 'Ruby',
    value: 'Ruby',
  },
  {
    label: 'RuneScript',
    value: 'RuneScript',
  },
  {
    label: 'Rust',
    value: 'Rust',
  },
  {
    label: 'S',
    value: 'S',
  },
  {
    label: 'S-Lang',
    value: 'S-Lang',
  },
  {
    label: 'S-PLUS',
    value: 'S-PLUS',
  },
  {
    label: 'S/SL',
    value: 'S/SL',
  },
  {
    label: 'S2',
    value: 'S2',
  },
  {
    label: 'S3',
    value: 'S3',
  },
  {
    label: 'SA-C',
    value: 'SA-C',
  },
  {
    label: 'SabreTalk',
    value: 'SabreTalk',
  },
  {
    label: 'SAIL',
    value: 'SAIL',
  },
  {
    label: 'SALSA',
    value: 'SALSA',
  },
  {
    label: 'SAM76',
    value: 'SAM76',
  },
  {
    label: 'SAS',
    value: 'SAS',
  },
  {
    label: 'SASL',
    value: 'SASL',
  },
  {
    label: 'Sather',
    value: 'Sather',
  },
  {
    label: 'Sawzall',
    value: 'Sawzall',
  },
  {
    label: 'SBL',
    value: 'SBL',
  },
  {
    label: 'Scala',
    value: 'Scala',
  },
  {
    label: 'Scheme',
    value: 'Scheme',
  },
  {
    label: 'Scilab',
    value: 'Scilab',
  },
  {
    label: 'Scratch',
    value: 'Scratch',
  },
  {
    label: 'Script.NET',
    value: 'Script.NET',
  },
  {
    label: 'Sed',
    value: 'Sed',
  },
  {
    label: 'Seed7',
    value: 'Seed7',
  },
  {
    label: 'Self',
    value: 'Self',
  },
  {
    label: 'SenseTalk',
    value: 'SenseTalk',
  },
  {
    label: 'SequenceL',
    value: 'SequenceL',
  },
  {
    label: 'SETL',
    value: 'SETL',
  },
  {
    label: 'SGML',
    value: 'SGML',
  },
  {
    label: 'SIGNAL',
    value: 'SIGNAL',
  },
  {
    label: 'SiMPLE',
    value: 'SiMPLE',
  },
  {
    label: 'SIMPOL',
    value: 'SIMPOL',
  },
  {
    label: 'SIMSCRIPT',
    value: 'SIMSCRIPT',
  },
  {
    label: 'Simula',
    value: 'Simula',
  },
  {
    label: 'Simulink',
    value: 'Simulink',
  },
  {
    label: 'Singularity',
    value: 'Singularity',
  },
  {
    label: 'SISAL',
    value: 'SISAL',
  },
  {
    label: 'SLIP',
    value: 'SLIP',
  },
  {
    label: 'SMALL',
    value: 'SMALL',
  },
  {
    label: 'Small Basic',
    value: 'Small Basic',
  },
  {
    label: 'Smalltalk',
    value: 'Smalltalk',
  },
  {
    label: 'SML',
    value: 'SML',
  },
  {
    label: 'Snap!',
    value: 'Snap!',
  },
  {
    label: 'SNOBOL',
    value: 'SNOBOL',
  },
  {
    label: 'Snowball',
    value: 'Snowball',
  },
  {
    label: 'SOL',
    value: 'SOL',
  },
  {
    label: 'SP/k',
    value: 'SP/k',
  },
  {
    label: 'Span',
    value: 'Span',
  },
  {
    label: 'SPARK',
    value: 'SPARK',
  },
  {
    label: 'Speedcode',
    value: 'Speedcode',
  },
  {
    label: 'SPIN',
    value: 'SPIN',
  },
  {
    label: 'SPITBOL',
    value: 'SPITBOL',
  },
  {
    label: 'SPS',
    value: 'SPS',
  },
  {
    label: 'SQL',
    value: 'SQL',
  },
  {
    label: 'SQR',
    value: 'SQR',
  },
  {
    label: 'Squeak',
    value: 'Squeak',
  },
  {
    label: 'Squirrel',
    value: 'Squirrel',
  },
  {
    label: 'SR',
    value: 'SR',
  },
  {
    label: 'Stackless Python',
    value: 'Stackless Python',
  },
  {
    label: 'Starlogo',
    value: 'Starlogo',
  },
  {
    label: 'Stata',
    value: 'Stata',
  },
  {
    label: 'Stateflow',
    value: 'Stateflow',
  },
  {
    label: 'Strand',
    value: 'Strand',
  },
  {
    label: 'Strongtalk',
    value: 'Strongtalk',
  },
  {
    label: 'Subtext',
    value: 'Subtext',
  },
  {
    label: 'SuperCollider',
    value: 'SuperCollider',
  },
  {
    label: 'SuperTalk',
    value: 'SuperTalk',
  },
  {
    label: 'SVG',
    value: 'SVG',
  },
  {
    label: 'Swift (Apple programming language)',
    value: 'Swift (Apple programming language)',
  },
  {
    label: 'Swift (parallel scripting language)',
    value: 'Swift (parallel scripting language)',
  },
  {
    label: 'SYMPL',
    value: 'SYMPL',
  },
  {
    label: 'SyncCharts',
    value: 'SyncCharts',
  },
  {
    label: 'SystemVerilog',
    value: 'SystemVerilog',
  },
  {
    label: 'T',
    value: 'T',
  },
  {
    label: 'T-SQL',
    value: 'T-SQL',
  },
  {
    label: 'TACL',
    value: 'TACL',
  },
  {
    label: 'TACPOL',
    value: 'TACPOL',
  },
  {
    label: 'TADS',
    value: 'TADS',
  },
  {
    label: 'TAL',
    value: 'TAL',
  },
  {
    label: 'Tcl',
    value: 'Tcl',
  },
  {
    label: 'Tea',
    value: 'Tea',
  },
  {
    label: 'TECO',
    value: 'TECO',
  },
  {
    label: 'TELCOMP',
    value: 'TELCOMP',
  },
  {
    label: 'TeX',
    value: 'TeX',
  },
  {
    label: 'TEX',
    value: 'TEX',
  },
  {
    label: 'TIE',
    value: 'TIE',
  },
  {
    label: 'Timber',
    value: 'Timber',
  },
  {
    label: 'TMG',
    value: 'TMG',
  },
  {
    label: 'Toi',
    value: 'Toi',
  },
  {
    label: 'Tom',
    value: 'Tom',
  },
  {
    label: 'TOM',
    value: 'TOM',
  },
  {
    label: 'TouchDevelop',
    value: 'TouchDevelop',
  },
  {
    label: 'TPU',
    value: 'TPU',
  },
  {
    label: 'Trac',
    value: 'Trac',
  },
  {
    label: 'Transcript',
    value: 'Transcript',
  },
  {
    label: 'TTCN',
    value: 'TTCN',
  },
  {
    label: 'TTM',
    value: 'TTM',
  },
  {
    label: 'Turbo C++',
    value: 'Turbo C++',
  },
  {
    label: 'Turing',
    value: 'Turing',
  },
  {
    label: 'Turtle',
    value: 'Turtle',
  },
  {
    label: 'TUTOR',
    value: 'TUTOR',
  },
  {
    label: 'TXL',
    value: 'TXL',
  },
  {
    label: 'TypeScript',
    value: 'TypeScript',
  },
  {
    label: 'Ubercode',
    value: 'Ubercode',
  },
  {
    label: 'UCSD Pascal',
    value: 'UCSD Pascal',
  },
  {
    label: 'Umple',
    value: 'Umple',
  },
  {
    label: 'Unicon',
    value: 'Unicon',
  },
  {
    label: 'Uniface',
    value: 'Uniface',
  },
  {
    label: 'UNITY',
    value: 'UNITY',
  },
  {
    label: 'Unix shell',
    value: 'Unix shell',
  },
  {
    label: 'UnrealScript',
    value: 'UnrealScript',
  },
  {
    label: 'Vala',
    value: 'Vala',
  },
  {
    label: 'Visual Basic',
    value: 'Visual Basic',
  },
  {
    label: 'Visual Basic .NET',
    value: 'Visual Basic .NET',
  },
  {
    label: 'Visual DataFlex',
    value: 'Visual DataFlex',
  },
  {
    label: 'Visual DialogScript',
    value: 'Visual DialogScript',
  },
  {
    label: 'Visual Fortran',
    value: 'Visual Fortran',
  },
  {
    label: 'Visual FoxPro',
    value: 'Visual FoxPro',
  },
  {
    label: 'Visual J#',
    value: 'Visual J#',
  },
  {
    label: 'Visual Objects',
    value: 'Visual Objects',
  },
  {
    label: 'Visual Prolog',
    value: 'Visual Prolog',
  },
  {
    label: 'VSXu',
    value: 'VSXu',
  },
  {
    label: 'vvvv',
    value: 'vvvv',
  },
  {
    label: 'WATFIV, WATFOR',
    value: 'WATFIV, WATFOR',
  },
  {
    label: 'WebDNA',
    value: 'WebDNA',
  },
  {
    label: 'WebQL',
    value: 'WebQL',
  },
  {
    label: 'Whiley',
    value: 'Whiley',
  },
  {
    label: 'Winbatch',
    value: 'Winbatch',
  },
  {
    label: 'Windows PowerShell',
    value: 'Windows PowerShell',
  },
  {
    label: 'Wolfram Language',
    value: 'Wolfram Language',
  },
  {
    label: 'Wyvern',
    value: 'Wyvern',
  },
  {
    label: 'X#',
    value: 'X#',
  },
  {
    label: 'X++',
    value: 'X++',
  },
  {
    label: 'X10',
    value: 'X10',
  },
  {
    label: 'XBL',
    value: 'XBL',
  },
  {
    label: 'XC',
    value: 'XC',
  },
  {
    label: 'xHarbour',
    value: 'xHarbour',
  },
  {
    label: 'XL',
    value: 'XL',
  },
  {
    label: 'XML',
    value: 'XML',
  },
  {
    label: 'XMOS architecture',
    value: 'XMOS architecture',
  },
  {
    label: 'Xojo',
    value: 'Xojo',
  },
  {
    label: 'XOTcl',
    value: 'XOTcl',
  },
  {
    label: 'XPath',
    value: 'XPath',
  },
  {
    label: 'XPL',
    value: 'XPL',
  },
  {
    label: 'XPL0',
    value: 'XPL0',
  },
  {
    label: 'XQuery',
    value: 'XQuery',
  },
  {
    label: 'XSB',
    value: 'XSB',
  },
  {
    label: 'XSLT',
    value: 'XSLT',
  },
  {
    label: 'Xtend',
    value: 'Xtend',
  },
  {
    label: 'YAML',
    value: 'YAML',
  },
  {
    label: 'Yoix',
    value: 'Yoix',
  },
  {
    label: 'Yorick',
    value: 'Yorick',
  },
  {
    label: 'YQL',
    value: 'YQL',
  },
  {
    label: 'Z notation',
    value: 'Z notation',
  },
  {
    label: 'Zeno',
    value: 'Zeno',
  },
  {
    label: 'ZOPL',
    value: 'ZOPL',
  },
  {
    label: 'ZPL',
    value: 'ZPL',
  },
  {
    label: 'Zsh',
    value: 'Zsh',
  },
];
